import React from "react";

const Dashboard = () => {
  return(
    <>
      Client Dashboard
    </>
  );
};
export default Dashboard;
